import { render, staticRenderFns } from "./newTasksIssues.vue?vue&type=template&id=8af07c34&scoped=true"
import script from "./newTasksIssues.vue?vue&type=script&lang=js"
export * from "./newTasksIssues.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./newTasksIssues.vue?vue&type=style&index=1&id=8af07c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af07c34",
  null
  
)

export default component.exports